module.exports = __webpack_public_path__ + "media/images/version_merge/unsuccess-31ba4a7c48a0b61035776c6f2d9380c8.png";